/* eslint-disable no-restricted-globals */
import React from 'react';

const useBeforeUnload = (enabled = true, message) => {
  let currentState = null;
  const onbeforeunloadHandler = React.useCallback(
    event => {
      if (!enabled) return;
      event.preventDefault();
      if (message) event.returnValue = message;
      return message;
    },
    [enabled, message]
  );
  const onpopstateHandler = React.useCallback(
    event => {
      let userAcceptance = false;
      const sameState =
        (history.state && history.state.key) ===
        (currentState && currentState.key);
      if (sameState) {
        userAcceptance = confirm(message);
      }
      if (userAcceptance) {
        history.go(-1);
      }
      if (event.state && enabled && !userAcceptance && sameState) {
        history.pushState(null, null, null);
      }
    },
    [enabled, message]
  );

  React.useEffect(() => {
    if (!enabled) return;
    currentState = history.state;
    history.pushState(null, null, null);
    window.addEventListener('beforeunload', onbeforeunloadHandler);
    window.addEventListener('popstate', onpopstateHandler);
    return () => {
      if (!history.state) {
        history.back();
      }
      currentState = null;
      window.removeEventListener('beforeunload', onbeforeunloadHandler);
      window.removeEventListener('popstate', onpopstateHandler);
    };
  }, [enabled, onbeforeunloadHandler, onpopstateHandler]);
};

export default useBeforeUnload;
